import React from 'react';
import Grid from '../Grid';
import ReadMoreLink from '../ReadMoreLink';
import {
  LockStyled,
  Article,
  MainTitle,
  Figure,
  TextBlock,
  TopTag,
  Title,
  Description,
  Graphic,
  FrontImage,
  BackImage
} from './styled';

const EmbeddedLock = () => {
  return (
    <LockStyled>
      <Grid>
        <MainTitle>Looking for an embedded login widget?</MainTitle>
        <Article>
          <TextBlock>
            <TopTag>
              <img src="https://cdn.auth0.com/website/universal-lock/lock-icon-new.svg" alt="" />
              <h3>LOCK</h3>
            </TopTag>
            <Title>Embedded login</Title>
            <Description>
              If you still prefer to embed the login box directly in your website instead of
              redirecting to the Universal login page, you won’t be disappointed. Lock would be the
              preferred approach to implement embedded login. The Lock widget can be easily embedded
              in your app, customized to enable multiple social providers and styled to match your
              brand. If you need more flexibility, you can create your own login page and use the
              Auth0.JS SDK to authenticate the user.
            </Description>
            <ReadMoreLink Href="https://auth0.com/lock">Learn More</ReadMoreLink>
          </TextBlock>
          <Figure>
            <Graphic
              src="https://cdn.auth0.com/website/universal-login/lock-panel-ui-box.svg"
              alt="Lock Panel UI"
            />
          </Figure>
        </Article>
      </Grid>
    </LockStyled>
  );
};

export default EmbeddedLock;



// WEBPACK FOOTER //
// ./src/pages/universal-login/components/EmbeddedLock/EmbeddedLock.js